import { useEffect, useRef, useState } from "react";
import { useMainContext } from "../../../Context";
import {
  newTicket,
  supportList,
  supportNewQuestion,
  supportChat,
} from "../../../Utils/Apis";

export const useSupport = () => {
  const [form, setForm] = useState({ show: false, selected: {} });
  const [data, setData] = useState({});
  const [loading, setLoading] = useState({ get: true });
  const { post } = useMainContext();

  const get = async () => {
    setLoading({ get: true });
    const { data, status } = await post(supportList);
    setData(data);
    setLoading({ get: false });
  };
  const send = async () => {
    console.log("a");
    setLoading({ ...loading, send: true });
    await post(newTicket, form, true);
    setLoading({ ...loading, send: false });
    setForm({ ...form, show: false });
  };
  useEffect(() => {
    if (!form.show) {
      get();
    }
    return;
  }, [form.show]);

  const handler = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  const toggle = () => setForm({ ...form, show: !form.show });
  const render = type => {
    switch (type) {
      case "waiting":
        return (
          <>
            <small className="badge fw-semi-bold rounded-pill badge-soft-warning">
              در انتظار پاسخ
            </small>
          </>
        );
      case "answerd":
        return (
          <>
            <small className="badge fw-semi-bold rounded-pill status badge-soft-primary">
              پاسخ داده شده
            </small>
          </>
        );
      case "closed":
        return (
          <>
            <small className="badge fw-semi-bold rounded-pill badge-soft-danger">
              بسته شده
            </small>
          </>
        );
        break;

      default:
        break;
    }
  };

  return { handler, get, send, loading, toggle, form, data, render };
};
export const useChat = ({ inintial }) => {
  const [form, setForm] = useState({ message: "" });
  const [chat, setChat] = useState({});
  const [loading, setLoading] = useState({ get: true });
  const { post } = useMainContext();

  const get = async () => {
    setLoading({ get: true });
    const { data, status } = await post(supportChat, {
      ticket_id: inintial.id,
    });
    setChat(data);
    setLoading({ get: false });
  };
  const send = async () => {
    console.log("a");
    setLoading({ ...loading, send: true });
    const { data } = await post(
      supportNewQuestion,
      { ...form, ticket_id: inintial.id },
      true
    );
    setChat({ ...chat, messages: data.messages });
    setLoading({ ...loading, send: false });
    setForm({ message: "" });
  };
  useEffect(() => {
    if (inintial.id) {
      get();
    }
  }, [inintial.id]);
  const messagesEndRef = useRef(null);
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    scrollToBottom();
  }, []);

  const handler = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  return {
    form,
    setForm,
    messagesEndRef,
    chat,
    loading,
    send,
    handler,
  };
};
